import { DatabaseZap, Gift, Icon, Wallet } from "lucide-react";
import React from "react";
import ProgressBar from "./ProgressBar";

export default function RecordCard({
  title1,
  value1,
  title2,
  value2,
  color,
  icon,
}) {
  const Icon = icon;
  return (
    <div
      className="bg-white w-full flex flex-col justify-between dark:bg-slate-900/80
       backdrop-blur-xl rounded-2xl 
       border border-slate-300/40 dark:border-slate-700/50 
       px-3 py-2
     "
    >
      <div className="flex items-center justify-between w-full">
        <div className="flex flex-col">
          <span className="text-sm font-medium font-sans text-slate-600 dark:text-slate-200">
            {title1}
          </span>

          <span className="text-lg  font-extrabold font-sans text-slate-600 dark:text-slate-200 ">
            {value1}
          </span>
        </div>
        <Icon
          className={`w-8 h-8 p-2 rounded-xl ${color.text} ${color.icon_bg}  `}
        />
      </div>
      <div className="mt-2">
        {/* <ProgressBar
      progressPercentage={20}
      color={color.progress_bg}
      /> */}
        <div className="border-b dark:border-slate-400/15 border-slate-500/10" />
      </div>
      <div className=" flex items-center justify-between">
        <span className="text-sm   font-medium font-sans text-slate-600 dark:text-slate-200">
          {title2}
        </span>
        <span className="text-md  font-semibold font-sans  text-slate-600 dark:text-slate-200 ">
          {value2}
        </span>
      </div>
    </div>
  );
}
